import { render, staticRenderFns } from "./Lookup.vue?vue&type=template&id=1e537909&"
import script from "./Lookup.vue?vue&type=script&lang=js&"
export * from "./Lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e537909')) {
      api.createRecord('1e537909', component.options)
    } else {
      api.reload('1e537909', component.options)
    }
    module.hot.accept("./Lookup.vue?vue&type=template&id=1e537909&", function () {
      api.rerender('1e537909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/Lookup.vue"
export default component.exports